module.exports = __webpack_public_path__ + "img/bike4.3d745f66.webp";